var _path, _path2, _path3, _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobeyellow = function SvgGlobeyellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D874A",
    d: "M-965-462a2 2 0 0 1 2-2H838a2 2 0 0 1 2 2v5394c0 1.1-.895 2-2 2H-963c-1.105 0-2-.9-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M-963-464v1H838v-2H-963zm1803 2h-1v5394h2V-462zm-2 5396v-1H-963v2H838zm-1803-2h1V-462h-2v5394zm2 2v-1c-.552 0-1-.45-1-1h-2c0 1.66 1.343 3 3 3zm1803-2h-1c0 .55-.448 1-1 1v2c1.657 0 3-1.34 3-3zm-2-5396v1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm-1801 0v-1a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#globeyellow_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#globeyellow_svg__b)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 3284.14,
    height: 3284.14,
    x: -1642.07,
    y: -1642.07,
    transform: "matrix(-.41643 .41337 -.6329 -.058 -240.8 187.633)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,#f6f8fa 0deg,#f6f8fa 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 836,
    x: -804,
    y: -235,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.96470588445663452,\"g\":0.97254902124404907,\"b\":0.98039215803146362,\"a\":1.0},\"position\":0.0}],\"stopsVar\":[{\"color\":{\"r\":0.96470588445663452,\"g\":0.97254902124404907,\"b\":0.98039215803146362,\"a\":1.0},\"position\":0.0}],\"transform\":{\"m00\":-832.8532714843750,\"m01\":-1265.8127441406250,\"m02\":808.5329589843750,\"m10\":826.73394775390625,\"m11\":-116.01531219482422,\"m12\":-167.72633361816406},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    rx: 28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1050,
    height: 742,
    x: -611,
    y: -162,
    fill: "#fff",
    rx: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F5C344",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.5,
    clipPath: "url(#globeyellow_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.003 18.666a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.003 18.666c1.472 0 2.666-2.984 2.666-6.666s-1.194-6.667-2.666-6.667c-1.473 0-2.667 2.985-2.667 6.667s1.194 6.666 2.667 6.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.336 12h13.333"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "globeyellow_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 836,
    x: -804,
    y: -235,
    rx: 28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "globeyellow_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h16v16H4z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "globeyellow_svg__a",
    width: 1296,
    height: 852,
    x: -812,
    y: -239,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
};
export default SvgGlobeyellow;